module.exports = __webpack_public_path__ + "static/media/boss-bar-red-06.88641161.png";